// @flow
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { saveUserTemplateFromNotice } from 'actions/userTemplates';
import { toggleSearchResultsDialog } from 'actions/searchResultsDialog';
import { toggleNotamDetailsDialog } from 'actions/notamDetailsDialog';
import { setFollowedAircraft } from 'actions/rt';

import PropSheet from './PropSheet';

const mapStateToProps = ({
  browser,
  map: { selectedFeature: feature },
  rt: { followedAircraft },
  flags: { hasSubscription },
}) => ({
  browser,
  feature,
  followedAircraft,
  hasSubscription,
});

const mapDispatchToProps = {
  toggleSearchResultsDialog,
  toggleNotamDetailsDialog,
  setFollowedAircraft,
  pushRoute: push,
  saveUserTemplateFromNotice,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropSheet);



// WEBPACK FOOTER //
// ./components/PropSheet/index.js